export default __webpack_public_path__ + "static/media/live-tv.b7a41481.svg";